import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserFacadeService } from 'src/app/auth/state/user-facade.service';
import { TefterLogoComponent } from 'src/app/auth/components/primitives/tefter-logo/tefter-logo.component';
import { BrandService } from '../../services/brand.service';
import { OrganizationConfigFacadeService } from '../../state/organization-config/organization-config-facade.service';
import { ActiveModuleMap } from '../navigation/navigation-routes';
import { landingPath } from './landing';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  imports: [TefterLogoComponent],
})
export class HomeComponent implements OnInit {
  private router = inject(Router);
  private brandService = inject(BrandService);
  private userFacade = inject(UserFacadeService);
  private orgConfigFacade = inject(OrganizationConfigFacadeService);

  ngOnInit(): void {
    // TX mode: always redirect to tx-orders (the only meaningful landing page)
    if (this.brandService.isTxMode()) {
      this.router.navigate(['/app/tx-orders']);
      return;
    }

    // Org-less users (fresh registrants, pending join requests) land silently
    // on the profile page instead of triggering the org-required snackbar.
    const currentUser = this.userFacade.getCurrentUser();
    const hasOrg = !!currentUser?.orgId || (currentUser?.orgIds?.length ?? 0) > 0;
    if (!hasOrg) {
      this.router.navigate(['/app/profile']);
      return;
    }

    // docs/specs/2026-10-08-member-landing-page.md: a pinned module, else the landing table; null stays home.
    const member = this.userFacade.getOrgUser();
    const path = landingPath({
      roles: member?.roles ?? [],
      activeModules: this.orgConfigFacade.getActiveModules() as ActiveModuleMap | null,
      brandModules: this.brandService.availableModules(),
      brandEntitles: this.brandService.isWhiteLabelMode(),
      landingModule: member?.landingModule,
    });
    if (path) this.router.navigate([path]);
  }
}
